import { Controller } from "@hotwired/stimulus"
import ClinicRemindersToggle from "@components/invoice_reminders/clinic-reminders-toggle.svelte"
import { mount, unmount } from "svelte"
import { isPreviewMode } from "@lib/utils"

const COMPONENT_KEY = "__svelteComponent"

// Connects to data-controller="clinic-reminders-toggle-svelte"
export default class extends Controller {

  connect() {
    if (isPreviewMode()) return

    this.teardown()
    if (this.beforeCache) document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.beforeCache = () => this.teardown()
    document.addEventListener("turbo:before-cache", this.beforeCache)

    const component = mount(ClinicRemindersToggle, { target: this.element })
    this.component = component
    this.element[COMPONENT_KEY] = component
  }

  disconnect() {
    if (this.beforeCache) {
      document.removeEventListener("turbo:before-cache", this.beforeCache)
      this.beforeCache = null
    }
    this.teardown()
  }

  teardown() {
    const existing = this.element[COMPONENT_KEY] || this.component
    if (existing) unmount(existing)
    this.element[COMPONENT_KEY] = null
    this.component = null
    this.element.innerHTML = ""
  }
}
